import { Action, createReducer, on } from '@ngrx/store';
import {
  ADD_MESSAGE,
  RESET_MESSAGE,
} from './messages.actions';
import { IMessageState } from './messages';

/* INITIAL STATE */
const initialState: IMessageState = {
  message: null
};

const handleAddMessage = (
  state: IMessageState,
  { message }: { message: string }
): IMessageState => {
  return {
    ...state,
    message,
  };
};

const handleResetMessage = (
  state: IMessageState,
): IMessageState => {
  return {
    ...state,
    message: null
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(ADD_MESSAGE, handleAddMessage),
  on(RESET_MESSAGE, handleResetMessage),
);

export const messagesReducer = (
  state: IMessageState | undefined,
  action: Action
): IMessageState => reducer(state, action);
